
if (!customElements.get('notify-me-klavio')) {
  customElements.define('notify-me-klavio', class NotifyMeKlavyio extends HTMLElement {
    constructor() {
      super();
      this.companyId = this.dataset.companyId
      this.smsId = this.dataset.smsId
      this.hasSMS = Boolean(this.smsId)
      this.emailId = this.dataset.emailId
      this.submitbtn = this.querySelector('[data-kalvyio-submit]');
      this.submitbtn.addEventListener('click', this.submitBIS.bind(this))
      this.telNumberInput = this.querySelector('#tel-number');
      this.consentSMSCheckbox = this.querySelector('[data-notify-consent-sms]');
      this.telNumberInput.addEventListener('focusout', this.telNumberWarningInput.bind(this));
      this.consentSMSCheckbox.addEventListener('change', this.consentSMSCheck.bind(this));

    }

    consentSMSCheck(evt) {
      if(!this.hasSMS) return
      const telNumber = this.querySelector('#tel-number');
      const consentWarning = this.querySelector('.consent-warning-msg');
      if(evt.target.checked) {
        consentWarning.innerHTML = ''
      } else if(telNumber.validity.valid) {
        consentWarning.innerHTML = 'Please opt in to receive SMS stock notifications'
      }
    }

    telNumberWarningInput(evt) {
      if(!this.hasSMS) return
      const consentWarning = this.querySelector('.consent-warning-msg');
      if(evt.target.value == '') {
        consentWarning.innerHTML = ''
        return
      }
      consentWarning.innerHTML = ''
      const consentSMS = this.querySelector('[data-notify-consent-sms]');
      if(consentSMS.checked) return
      console.log(this.telNumberInput.value)

      consentWarning.innerHTML = 'Please opt in to receive SMS stock notifications'
    }

    submitBIS(evt) {
      evt.preventDefault()
      const variantId = this.querySelector('[data-notify-me-variant]').dataset.variantId

      const form = this.querySelector('.notify-me-form');
      const telNumber = this.querySelector('#tel-number');
      const telNumerValue = telNumber?.value && telNumber.value.replace(/\D|^0+/g, "").trim();
      const countryCode = this.querySelector('.country-code');
      const consent = this.querySelector('[data-notify-consent]');
      const consentSMS = this.querySelector('[data-notify-consent-sms]');
      const email = this.querySelector('#email');
      const phoneErrorMsg = this.querySelector('.phone-error-msg');
      const emailErrorMsg = this.querySelector('.email-error-msg');
      const generalErrorMsg = this.querySelector('.general-error-msg');
      const successMessage = this.querySelector('.success-msg');
      phoneErrorMsg.innerHTML = ''
      emailErrorMsg.innerHTML = ''
      generalErrorMsg.innerHTML = ''
      successMessage.innerHTML = ''

      if (!email.validity.valid && !telNumber.validity.valid) {
        
        generalErrorMsg.innerHTML = 'Please enter a valid mobile number or email address'
        if(!this.hasSMS) generalErrorMsg.innerHTML = 'Please enter a valid email address'

        if(!telNumber.validity.valid && telNumerValue !== '') {
          phoneErrorMsg.innerHTML = 'Please check your mobile number'
        }
        if(!email.validity.valid && email.value !== '') {
          emailErrorMsg.innerHTML = 'Please check your email'
        }
        return
      }

      if(telNumber.validity.valid && !countryCode.validity.valid) {
        phoneErrorMsg.innerHTML = 'Please select a country code'
        return
      }

      if(telNumber.validity.valid && countryCode.validity.valid && !consentSMS.checked ) {
        consentWarning.innerHTML = 'Please opt in to receive SMS stock notifications'
        return
      }

      
      let payload = {
        "data": {
          "type": "back-in-stock-subscription",
          "attributes": {
            "profile": {
              "data": {
                  "type": "profile",
                  "attributes": {
                      "phone_number": '+'+countryCode.value+telNumerValue,
                      "email": email.value,
                  }
              }
            },
            "channels": ["SMS", "EMAIL"],
          },
          "relationships": {
            "variant": {
              "data": {
                "type": "catalog-variant",
                "id": `$shopify:::$default:::${variantId}`
              }
            }
          }
        }
      }

      if(email.validity.valid && !telNumber.validity.valid) {
        payload = {
          "data": {
            "type": "back-in-stock-subscription",
            "attributes": {
              "profile": {
                "data": {
                    "type": "profile",
                    "attributes": {
                        "email": email.value,
                    }
                }
              },
              "channels": ["EMAIL"],
            },
            "relationships": {
              "variant": {
                "data": {
                  "type": "catalog-variant",
                  "id": `$shopify:::$default:::${variantId}`
                }
              }
            }
          }
        }

      } else if(!email.validity.valid && telNumber.validity.valid && countryCode.validity.valid) {
        payload = {
          "data": {
            "type": "back-in-stock-subscription",
            "attributes": {
              "profile": {
                "data": {
                    "type": "profile",
                    "attributes": {
                        "phone_number": '+'+countryCode.value+telNumerValue,
                    }
                }
              },
              "channels": ["SMS"],
            },
            "relationships": {
              "variant": {
                "data": {
                  "type": "catalog-variant",
                  "id": `$shopify:::$default:::${variantId}`
                }
              }
            }
          }
        }


      }

      var requestOptions = {
          method: 'POST',
          headers: {
            "Content-Type": "application/json",
            "revision":"2024-06-15"
          },
          body: JSON.stringify(payload),
      };

      fetch("https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id="+this.companyId ,requestOptions)
      .then(result => {
        if(result.status === 202) {
          successMessage.innerHTML = 'Thank you, we will be in touch'
          setTimeout(() => {
            this.querySelector('.product-modal__close').click()
          }, 2000);
          return
        }
        if(result.status !== 202) {
          generalErrorMsg.innerHTML = 'Please check the mobile number or email address is correct'
        }
      })
      .catch(error => {
        console.log('error', error)
      });

      if(consent.checked && email.validity.valid) {
        this.consent()
      }

      if(telNumber.validity.valid && consentSMS.checked ) {
        this.consentSMS()
      }

    }

    //Email marketing Consent
    consent() {

      const email = this.querySelector('#email');

      let payload = {
        "data": {
          "type": "subscription",
          "attributes": {
            "profile": {
              "data": {
                "type": "profile",
                "attributes": {
                    "email": email.value,
                  "subscriptions": {
                    "email": {
                      "marketing": {
                        "consent": "SUBSCRIBED"
                      }
                    }
                  }
                }
              }
            }
          },
          "relationships": {
            "list": {
              "data": {
                "type": "list",
                "id": this.emailId
              }
            }
          }
        }
      }
      const options = {
        method: 'POST',
        headers: {revision: '2025-01-15', 'content-type': 'application/vnd.api+json'},
        body: JSON.stringify(payload),
      };
      
      fetch('https://a.klaviyo.com/client/subscriptions/?company_id='+this.companyId, options)
        .then(res => res)
        .then(res => console.log(res))
        .catch(err => console.error(err));
    }

    //SMS Marketing Consent
    consentSMS() {
      if(!this.hasSMS) return
      const telNumber = this.querySelector('#tel-number');
      const telNumerValue = telNumber.value && telNumber.value.replace(/\D|^0+/g, "").trim();
      const countryCode = this.querySelector('.country-code');

      let payload = {
        "data": {
          "type": "subscription",
          "attributes": {
            "profile": {
              "data": {
                "type": "profile",
                "attributes": {
                  "phone_number": '+'+countryCode.value+telNumerValue,
                  "subscriptions": {
                    "sms": {
                      "marketing": {
                        "consent": "SUBSCRIBED"
                      },
                      "transactional": {
                        "consent": "SUBSCRIBED"
                      }
                    }
                  }
                }
              }
            }
          },
          "relationships": {
            "list": {
              "data": {
                "type": "list",
                "id": this.smsId
              }
            }
          }
        }
      }
      const options = {
        method: 'POST',
        headers: {revision: '2025-01-15', 'content-type': 'application/vnd.api+json'},
        body: JSON.stringify(payload),
      };
      
      fetch('https://a.klaviyo.com/client/subscriptions/?company_id='+this.companyId, options)
      .then(res => res)
      .then(res => console.log(res))
      .catch(err => console.error(err));
    }

    // Consent to receive BIS (back in stock) SMS - required for this to work
    // notifyConsentSMS() {
    //   const telNumber = this.querySelector('#tel-number');
    //   const telNumerValue = telNumber.value && telNumber.value.replace(/\D|^0+/g, "").trim();
    //   const countryCode = this.querySelector('.country-code');

    //   let payload = {
    //     "data": {
    //       "type": "subscription",
    //       "attributes": {
    //         "profile": {
    //           "data": {
    //             "type": "profile",
    //             "attributes": {
    //               "phone_number": '+'+countryCode.value+telNumerValue,
    //               "subscriptions": {
    //                 "email": {
    //                   "marketing": {
    //                     "consent": "SUBSCRIBED"
    //                   }
    //                 },
    //                 "sms": {
    //                   "marketing": {
    //                     "consent": "SUBSCRIBED"
    //                   },
    //                   "transactional": {
    //                     "consent": "SUBSCRIBED"
    //                   }
    //                 }
    //               }
    //             }
    //           }
    //         }
    //       },
    //       "relationships": {
    //         "list": {
    //           "data": {
    //             "type": "list",
    //             "id": "XCdngz"
    //           }
    //         }
    //       }
    //     }
    //   }
    //   const options = {
    //     method: 'POST',
    //     headers: {revision: '2025-01-15', 'content-type': 'application/vnd.api+json'},
    //     body: JSON.stringify(payload),
    //   };
      
    //   fetch('https://a.klaviyo.com/client/subscriptions/?company_id=WcxtWw', options)
    //   .then(res => res)
    //   .then(res => console.log(res))
    //   .catch(err => console.error(err));
    // }
  });
}



